export default "__VITE_ASSET__82df2ba8__"